import { METERS_PER_MILE } from '@gpx-spa/ui';

const METERS_PER_FOOT = 0.3048;
/** ~0.1 mi — same switch-over as labs `formatDistance` / `formatRadius`. */
const FEET_BEFORE_MILES = 528;

/**
 * Format a positive accuracy radius (metres from API) for customer popups.
 * Imperial-first: feet under ~0.1 mi, then miles.
 */
export function formatAccuracyDistanceMeters(meters: number): string {
  const feet = meters / METERS_PER_FOOT;
  if (feet < FEET_BEFORE_MILES) return `${Math.round(feet)} ft`;
  const miles = meters / METERS_PER_MILE;
  return miles < 10 ? `${miles.toFixed(1)} mi` : `${Math.round(miles)} mi`;
}
